import React, { useEffect, useState } from "react";
import GlobalHeader from "../../components/GlobalHeader";
import { Box, Container, Stack, Typography } from "@mui/material";
import useApi from "../../hooks/useApi";
import { Audio } from "react-loading-icons";
// Estilos de Quill: el contenido se edita con ReactQuill en el panel admin,
// así que las clases ql-* (alineación, indentación, listas) necesitan su CSS.
import "react-quill/dist/quill.core.css";

import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

// Tipografía legible para el HTML que viene del editor del admin
const contentStyles = {
  "&.ql-editor": {
    padding: 0,
    fontFamily: "inherit",
    fontSize: "1rem",
    whiteSpace: "normal",
    textAlign: "left",
    lineHeight: 1.7,
    color: "#333",
    height: "auto",
    overflowY: "visible",
  },
  "& h1, & h2, & h3": {
    color: "primary.main",
    marginTop: "1.2em",
    marginBottom: "0.4em",
    lineHeight: 1.3,
  },
  "& p": {
    marginBottom: "0.6em",
  },
  "& ul, & ol": {
    paddingLeft: "1.5em",
    marginBottom: "0.8em",
  },
  "& a": {
    color: "primary.main",
  },
  "& img": {
    maxWidth: "100%",
  },
};

const HtmlContent = ({ html, emptyMessage }) => {
  if (!html || !html.replace(/<[^>]*>/g, "").trim()) {
    return (
      <Stack alignItems="center" py={6}>
        <Typography variant="h6" color="GrayText" fontWeight={400}>
          {emptyMessage}
        </Typography>
      </Stack>
    );
  }
  return (
    <Box
      className="ql-editor"
      sx={contentStyles}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

const Faqs = () => {

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };


  const { loadApi, loadedApi } = useApi()
  const [ faqs, setFaqs ] = useState("")
  const [ terminos, setTerminos ] = useState("")

  useEffect(() => {
    loadApi("general/parametros", false, "get").then((res) => {
      setFaqs(res.data.faqs);
      setTerminos(res.data.terminos);
    });
  }, []);

  const loading = !loadedApi.includes("get__general/parametros");

  return (
    <>
      <GlobalHeader />
      <Container maxWidth="md" sx={{ pt: 3, pb: 6 }}>
        <Typography
          variant="h4"
          color="primary.main"
          fontWeight="900"
          fontSize={{ xs: "24px", sm: "34px" }}
          mb={2}
        >
          CENTRO DE AYUDA
        </Typography>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="tabs">
            <Tab label="Preguntas frecuentes" {...a11yProps(0)} />
            <Tab label="Términos y condiciones" {...a11yProps(1)} />
          </Tabs>
        </Box>
        {loading ? (
          <Stack alignItems="center" py={8}>
            <Audio fill="#F27224" />
          </Stack>
        ) : (
          <>
            <CustomTabPanel value={value} index={0}>
              <HtmlContent
                html={faqs}
                emptyMessage="Aún no hay preguntas frecuentes publicadas"
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <HtmlContent
                html={terminos}
                emptyMessage="Aún no hay términos y condiciones publicados"
              />
            </CustomTabPanel>
          </>
        )}
      </Container>
    </>
  );
};

export default Faqs;
